import axiosClient from "../axiosClient";
import { CreatePetiteAnnonceData } from "../interfaces/create-petite-annonce-data.interface";
import { PetiteAnnonce } from "../interfaces/petite-annonce.interface";

export const findAllPetitesAnnonces = async () => {
  const response = await axiosClient.get<PetiteAnnonce[]>("/petites-annonces");
  return response.data;
};

export const findPetiteAnnonceById = async (id: string) => {
  const response = await axiosClient.get<PetiteAnnonce>(`/petites-annonces/${id}`);
  return response.data;
};

export const deletePetiteAnnonce = async (id: string) => {
  const response = await axiosClient.delete(`/petites-annonces/${id}`);
  return response.data;
};

export const getCreatePetiteAnnonceData = async () => {
  const response = await axiosClient.get<CreatePetiteAnnonceData>("/petites-annonces/creation-data");
  return response.data;
};
